<script setup lang="ts">
interface Props {
  to: string | Record<string, unknown>
  variant?: 'primary' | 'secondary' | 'ghost' | 'inverted' | 'outline-inverted'
  size?: 'sm' | 'md' | 'lg'
  icon?: string
  iconPosition?: 'left' | 'right'
  fullWidth?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'md',
  iconPosition: 'left',
  fullWidth: false,
})

const classes = computed(() => {
  const result = [
    'inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-colors duration-200',
    'focus-visible:outline-2 focus-visible:outline-offset-2',
  ]
  const sizes = {
    sm: 'min-h-10 px-3 py-2 text-sm',
    md: 'min-h-11 px-4 py-2.5 text-base',
    lg: 'min-h-12 px-6 py-3 text-lg',
  }
  const variants = {
    primary: 'bg-brand-600 text-white hover:bg-brand-700 focus-visible:outline-brand-600',
    secondary: 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 focus-visible:outline-brand-600 dark:border-gray-600 dark:bg-gray-900 dark:text-white dark:hover:bg-gray-800',
    ghost: 'text-gray-700 hover:bg-gray-100 focus-visible:outline-brand-600 dark:text-gray-200 dark:hover:bg-gray-800',
    inverted: 'border border-white bg-white text-brand-800 shadow-lg hover:bg-emerald-50 focus-visible:outline-white',
    'outline-inverted': 'border-2 border-white bg-transparent text-white hover:bg-white/10 focus-visible:outline-white',
  }
  result.push(sizes[props.size], variants[props.variant])
  if (props.fullWidth) result.push('w-full')
  return result.join(' ')
})
</script>

<template>
  <NuxtLink :to="to" :class="classes">
    <UIcon v-if="icon && iconPosition === 'left'" :name="icon" class="size-5" />
    <slot />
    <UIcon v-if="icon && iconPosition === 'right'" :name="icon" class="size-5" />
  </NuxtLink>
</template>
